import React from "react";
import { AdminLoginContent } from "src/content";

const AdminLogin = () => {
  return <AdminLoginContent />;
};

export default AdminLogin;
